import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetCServiceLogonResData } from "./GetCServiceLogonResData";

const ENDPOINT = "/log_analysis/cservicelogon";

export class GetCServiceLogonCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetCServiceLogonReqData = null;

    constructor(installationName: string, serialNumber: string, dateStart: Date, dateEnd: Date) {
        super();
        this.params = new GetCServiceLogonReqData(installationName, serialNumber, dateStart, dateEnd);
    }

    public async execute(): Promise<GetCServiceLogonResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetCServiceLogonResData(res);
    }
}

export class GetCServiceLogonReqData {
    // FilterInstallations
    installationName: string = null;
    serialNumber: string = null;
    dateStart: Date = null;
    dateEnd: Date = null;

    constructor(installationName: string, serialNumber: string, dateStart: Date, dateEnd: Date) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }
}
